export const BASE_URL = process.env.REACT_APP_BACKEND_URL ??'https://projeto-sds4-production.up.railway.app';
